import axios from "axios";
import { baseUrl } from "../config/urls";
import { getAccessToken } from "./auth";
import store from "../../store/store";
import { AnnualPricing, LifetimePricing } from "../config/pricing";
import { notify } from "./notification";
import { changeStore } from "../../store/useStore";

export const getPlanDetailsFromPlanID = (id: number|string): any | undefined => {
  let plans: any[] = [...LifetimePricing, ...AnnualPricing];
  if (typeof id === 'string') {
    id = parseInt(id, 10);
  }
  let plan = plans.find((plan) => plan.index === id);
  return plan;
};

export const setAllTransactions = async (): Promise<any> => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/topup/get_user_transactions`,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    if (response?.status === 200) {
      let allTransactions = response?.data;
      if (allTransactions?.length > 0) {
        allTransactions = allTransactions.map((transaction: { 
          amount: string;
          createdAt: number;
          id: string;
          network: string;
          planID?: string;
          publicKey: string;
          subscriptionID: string;
          tokenAddress: string;
          txHash: string;
        }) => {
        if (!transaction.hasOwnProperty('planID')) {
          transaction.planID = transaction.subscriptionID;
        }
        return transaction;
      });
      }
      const userData = store.getState().balance;
      const newUserData = {...userData};
      newUserData['allTransactions'] = allTransactions;
      changeStore("setBalanceData", newUserData);
      return allTransactions;
    }
  } catch (err) {
    return [];
  }
};

export const createReferedByEntry = async (): Promise<void> => {
  const referBy = localStorage.getItem("files.lighthouse.storage/referBy");
  if (referBy && referBy !== "null" && referBy !== "") {
    try {
      const response = await axios.get(
        `${baseUrl}/api/user/create_referral?referredBy=${referBy}`,
        {
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
        }
      );
      if (response?.status === 200) {
        localStorage.removeItem("files.lighthouse.storage/referBy");
      }
    } catch (err) {
      // Handle error if necessary
    }
  }
};


export const cancelSubscription = async (data:any,setConfirmationDialog:any): Promise<void> =>{
  try {
    const userData = store.getState().balance;
    const response = await axios.post(
      `${baseUrl}/api/topup/cancel_user_subscription?subscriptionId=${data.subscriptionID}`,{user:{
        email:userData.email
      }},
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    if(response.status === 200){
      notify(response.data.message,'success');
      setConfirmationDialog(false);
    } 
  } catch (error) {
    notify('Something went wrong, Please try again','error');    
  }

}